import type { TypeRangeKey } from '@/types/begateway/types.begateway.traffic';
import type { TypeTrafficStep } from '@/types/traffic/types.traffic';

export const RANGE_OPTIONS: { value: TypeRangeKey; label: string }[] = [
    { value: '24h', label: '24 ore' },
    { value: '7d', label: '7 giorni' },
    { value: '30d', label: '30 giorni' },
];

export const RANGE_STEP: Record<TypeRangeKey, TypeTrafficStep> = { '24h': '15m', '7d': '1h', '30d': '6h' };

export const RANGE_COMPARISON: Record<TypeRangeKey, string> = {
    '24h': 'vs 24 h prima',
    '7d': 'vs 7 giorni prima',
    '30d': 'vs 30 giorni prima',
};

const STEP_LABEL: Record<string, string> = {
    '5m': 'bucket da 5 minuti', '15m': 'bucket da 15 minuti', '30m': 'bucket da 30 minuti',
    '1h': 'bucket da 1 ora', '3h': 'bucket da 3 ore', '6h': 'bucket da 6 ore', '12h': 'bucket da 12 ore', '1d': 'bucket da 1 giorno',
};

export const stepLabel = (step: string): string => STEP_LABEL[step] ?? `bucket da ${step}`;

export const TIER_LABEL: Record<string, string> = {
    fine: 'rollup da 5 minuti',
    hourly: 'rollup orari',
    mixed: 'rollup orari, ultime ore a 5 minuti',
};

export function trafficParams(query: Record<string, unknown>): Record<string, string | number | boolean> {
    const params: Record<string, string | number | boolean> = {};
    for (const [key, value] of Object.entries(query)) {
        if (value === undefined || value === null || value === '') continue;
        if (typeof value === 'string' || typeof value === 'number' || typeof value === 'boolean') params[key] = value;
        else if (Array.isArray(value)) params[key] = value.join(',');
    }
    return params;
}
